import { registerStep } from "./stepsRegistry";
import type { StepDefinition } from "./types";
import { RepresentanteLegalStep } from "@/components/form-steps/RepresentanteLegalStep";
import { RepresentanteLegalSchema } from "@/schemas/multistep/representante-legal.schema";

const definition: StepDefinition = {
  id: "representanteLegal",
  title: "Representante Legal",
  schema: RepresentanteLegalSchema,
  Component: RepresentanteLegalStep,
  isApplicable: (tipoDocumento: string = ""): boolean => {
    return tipoDocumento === "NIT";
  },
};

registerStep(definition);
